import { render, staticRenderFns } from "./TechnicalHandoverProtocolDialog.vue?vue&type=template&id=34b506aa&scoped=true"
import script from "./TechnicalHandoverProtocolDialog.vue?vue&type=script&lang=js"
export * from "./TechnicalHandoverProtocolDialog.vue?vue&type=script&lang=js"
import style0 from "./TechnicalHandoverProtocolDialog.vue?vue&type=style&index=0&id=34b506aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b506aa",
  null
  
)

export default component.exports